// mysql components
const MySQL = () => import("Core/configuration/developer/views/MySQL");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/mysql/:id(\\d+)?",
            name: "settings_mysql",
            component: MySQL,
            meta: {
                requiresAuth: true,
                title: "lang.mysql",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
